/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["a[_ngcontent-%COMP%]{color:rgba(150,168,192,.5)}.column[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;height:100%}.context[_ngcontent-%COMP%]{height:100%;flex-direction:column;display:flex;justify-content:center;padding:16px;text-align:center;color:rgba(150,168,192,.5)}.context__logo[_ngcontent-%COMP%]{width:40px;display:block;margin:20px auto;opacity:.3}"];
export { styles as styles };
